import { ComponentProps, JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { ListItem as SerendieListItem } from "@serendie/ui";
import "./Styles.scss";

export class ListItem extends BaseComponent<IListItemProps, IListItemState>
{
    public render(): JSX.Element
    {
        return <SerendieListItem
            {...this.props}
            className={`${this.props.className} serendie-list-item ${this.props.title ? '' : 'serendie-list-item--no-title'}`}
            title={this.props.title ?? ''}
        />
    }
}

export interface IListItemProps extends ListItemProps { }
export type ListItemProps = ComponentProps<"li"> & ListItemBaseProps;

export interface ListItemBaseProps
{
    title?: string;
    description?: string;
    rightIcon?: React.ReactElement;
    leftIcon?: React.ReactElement;
    isLargeLeftIcon?: boolean;
    //badge?: number;
    children?: React.ReactNode;
    disabled?: boolean;
    selected?: boolean;
    focusVisible?: boolean;
    size?: "small";
}

export interface IListItemState { }
